import { Box, Grid, styled, Typography } from '@mui/material';
import GridContainer from 'components/GridContainer';
import Spacing from 'components/Spacing';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { CalendarDay, numberToCurrencyString } from 'further-ui/utils';

const Details = styled(Box)(({ theme }) => ({
  height: '164px',
  width: '100%',
  border: `1px solid ${theme.palette.grey[300]}`,
  padding: theme.spacing(7, theme.spacingSizes.md),

  [theme.breakpoints.down('md')]: {
    height: 'auto',
  },
}));

const Label = styled(Typography)(({ theme }) => ({
  ...theme.typography.h6,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  wordBreak: 'break-word',
}));

type Props = {
  description: string;
  counterparty: string;
  date: CalendarDay;
  spent?: number;
  received?: number;
  accountCurrency: CurrencyCode;
};

const BankOperationDetails: React.FC<Props> = ({
  description,
  date,
  spent,
  received,
  accountCurrency,
  counterparty,
}) => {
  const spentAmount = numberToCurrencyString(
    spent ? Math.abs(spent) : undefined,
    {
      fallback: '-',
      currency: accountCurrency,
    },
  );
  const receivedAmount = numberToCurrencyString(received, {
    fallback: '-',
    currency: accountCurrency,
  });

  return (
    <Details>
      <GridContainer gap={4}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Spacing size="sm">
            <Typography variant="h6">{date.toLabel()}</Typography>
            <Typography variant="body2">{counterparty}</Typography>
            <Label>{description}</Label>
          </Spacing>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <Spacing size="sm">
            <Typography variant="body2">Spent</Typography>
            <Label>{spentAmount}</Label>
          </Spacing>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <Spacing size="sm">
            <Typography variant="body2" align="right">
              Received
            </Typography>
            <Label align="right">{receivedAmount}</Label>
          </Spacing>
        </Grid>
      </GridContainer>
    </Details>
  );
};

export default BankOperationDetails;
